import moment from 'moment';

export const sortByTime = (
  arr: any[],
  field: string | undefined = 'created_at',
) => {
  return arr.toSorted((itemA, itemB) =>
    moment(itemA[field]).isBefore(itemB[field]) ? -1 : 1,
  );
};
